import { snapRoundCustom } from '@calculations/round/decimal';
import {
  perQuantityFromSiteUnits,
  siteUnits,
} from '@calculations/utilities/selling-uom';

import {
  onPartUnitPriceChange,
  onServiceChargeUnitPriceChange,
} from '../../calculations/recalculate';
import { validateUnitPrice } from '../../validations/unit-price';
import { PriceFieldHandlerParams } from './types';

export function handlePartUnitPriceChange({
  state,
  quoteLineUuid,
  quotePriceUuid,
  value,
  priceStrategyConfigs,
}: PriceFieldHandlerParams) {
  const enteredUnitPrice = validateUnitPrice(state, {
    quoteLineUuid,
    quotePriceUuid,
    unitPrice: value,
  });

  if (!enteredUnitPrice) {
    return;
  }

  /**
   * The user enters a price per selling unit — "price per M" on a thousands
   * site — which is stored per each. Rounding stays in the entered unit so the
   * site's configured decimal places keep meaning what the user sees.
   */
  const unitPrice = perQuantityFromSiteUnits(
    siteUnits(snapRoundCustom(enteredUnitPrice, state.decimalPlaces)),
    { sellingUnitOfMeasure: state.sellingUnitOfMeasure },
  );

  onPartUnitPriceChange(state, {
    quoteLineUuid,
    quotePriceUuid,
    unitPrice,
    priceStrategyConfigs,
  });
}

export function handleServiceUnitPriceChange({
  state,
  quoteLineUuid,
  quotePriceUuid,
  value,
}: PriceFieldHandlerParams) {
  const unitPrice = validateUnitPrice(state, {
    quoteLineUuid,
    quotePriceUuid,
    unitPrice: value,
  });

  if (!unitPrice) {
    return;
  }

  onServiceChargeUnitPriceChange(state, {
    quoteLineUuid,
    quotePriceUuid,
    unitPrice,
  });
}
